import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {rdvActivationKeysStore} from "./rdvActivationQueries.js";
import {rdvPlanningSettingApiService} from "./rdvPlanningSettingApi.service.js";

export const rdvPlanningSettingKeysStore = {
  root: ["rdvPlanningSetting"] as const,
  current: () => [...rdvPlanningSettingKeysStore.root, "current"] as const,
};

export function useRdvPlanningSetting() {
  const {data, isLoading, isFetching, refetch} = useQuery({
    queryKey: rdvPlanningSettingKeysStore.current(),
    queryFn: rdvPlanningSettingApiService.getRdvPlanningSetting,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    rdvPlanningSetting: data,
    isRdvPlanningSettingLoading: isLoading,
    isRdvPlanningSettingFetching: isFetching,
    refetchRdvPlanningSetting: refetch,
  };
}

export function useUpdateRdvTravelSetting() {
  const queryClient = useQueryClient();
  const {mutateAsync, isPending} = useMutation({
    mutationFn: rdvPlanningSettingApiService.updateRdvTravelSetting,
    onSuccess(response) {
      queryClient.setQueryData(rdvPlanningSettingKeysStore.current(), response);
      // The travel-time edges are an RDV activation prerequisite (Story 5.1,
      // #607): refresh the activation status so the switch/missing list reflects
      // the edit without waiting for a remount.
      queryClient.invalidateQueries({queryKey: rdvActivationKeysStore.status()});
    },
    onError(error) {
      console.error("Failed to update RDV travel setting:", error);
    },
  });
  return {updateRdvTravelSetting: mutateAsync, isUpdatingRdvTravelSetting: isPending};
}

export function useUpdateRdvProposalLimit() {
  const queryClient = useQueryClient();
  const {mutateAsync, isPending} = useMutation({
    mutationFn: rdvPlanningSettingApiService.updateRdvProposalLimit,
    onSuccess(response) {
      queryClient.setQueryData(rdvPlanningSettingKeysStore.current(), response);
    },
  });
  return {updateRdvProposalLimit: mutateAsync, isUpdatingRdvProposalLimit: isPending};
}
